import React from "react";
import ContainerPreview from "../../../FormBuilderInputs/ContainerPreview";
import NormalInput from "../../../FormBuilderInputs/NormalInput";
import AntDatePicker from "../../../FormBuilderInputs/DatePicker";
import AntCheckBox from "../../../FormBuilderInputs/CheckBox";
import AntTextArea from "../../../FormBuilderInputs/TextArea";
import Toggle from "../../../FormBuilderInputs/Toggle";
import AntButton from "../../../FormBuilderInputs/Button";
import AntHeader from "../../../FormBuilderInputs/Header";
import Image from "../../../FormBuilderInputs/Image";
import Label from "../../../FormBuilderInputs/Label";
import Link from "../../../FormBuilderInputs/Link";
import ProgressCircle from "../../../FormBuilderInputs/ProgressCircle";
import ProgressLine from "../../../FormBuilderInputs/ProgressLine";
import Popup from "../../../Helpers/Popup/Popup";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import { Modal } from "react-bootstrap";
import trans from "../../../../utils";
import PopupBodyItem from "../../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import EditAttachments from "../../../Helpers/Dropzone/EditAttachments";
import RepeatingGroupSubmissionView from "../../../FormBuilderInputs/RepeatingGroupSubmissionView";
import { useGetSingleFormSubmissionQuery } from "../../../../Redux/service/Forms/Form";

export default function FormSubmissionPopup({ setView, view, data }) {
	// Fetch the full submission (including the pinned form schema) so
	// nested/repeating-group fields can be rendered with proper titles.
	const { data: fullSubmission } = useGetSingleFormSubmissionQuery(data?.id, {
		skip: !view || !data?.id,
	});

	const resolvedData = fullSubmission?.data || data;

	const getGroupFieldDefs = (groupKey) => {
		const schemaFields = resolvedData?.formSchema?.fields || [];
		const groupDef = schemaFields.find(
			(f) => f.key === groupKey && f.name === "RepeatingGroup"
		);
		return groupDef?.fields || [];
	};

	const getInputType = (item) => {
		switch (item?.name) {
			case "Checkbox":
				return <AntCheckBox item={item} readOnly={true} />;
			case "DatePicker":
			case "DateTime":
				return <AntDatePicker item={item} preview={true} disable={false} />;
			case "Dropdown":
				return <NormalInput item={item} preview={true} readOnly={true} />;
			case "MultiSelect": {
				const multiValue = Array.isArray(item?.value)
					? item.value
							.map((v) =>
								v && typeof v === "object"
									? v.displayValue ?? v.label ?? v.value ?? JSON.stringify(v)
									: String(v)
							)
							.join(", ")
					: "-";
				return (
					<div className="display-border p-2">
						<strong>{item.title || item.key}</strong>: {multiValue}
					</div>
				);
			}

			case "Input":
			case "numberinput":
			case "NumberInput":
				return <NormalInput item={item} preview={true} readOnly={true} />;
			case "Container":
				return (
					<ContainerPreview
						getInputType={getInputType}
						ukey={item?.id}
						item={item?.container}
						css={item?.css}
					/>
				);
			case "RepeatingGroup":
				return (
					<RepeatingGroupSubmissionView
						item={item}
						groupFieldDefs={getGroupFieldDefs(item.key)}
						getInputType={getInputType}
					/>
				);
			case "DerivedValue":
			case "ComputedValue":
				return <NormalInput item={item} preview={true} readOnly={true} />;
			case "Radio_group":
				return <NormalInput item={item} preview={true} readOnly={true} />;

			case "Text_area":
				return <AntTextArea item={item} preview={true} readOnly={true} />;

			case "Toggle":
				return <Toggle item={item} readOnly={true} />;
			case "Uploader":
				return;
			case "Button":
				return <AntButton item={item} />;

			case "Header":
				return <AntHeader item={item} />;
			case "Image":
				return <Image item={item} />;
			case "Label":
				return <Label item={item} />;
			case "Link":
				return <Link item={item} />;

			case "Progress_circle":
				return <ProgressCircle item={item} />;
			case "Progress_line":
				return <ProgressLine item={item} />;
			case "Signature":
				return;
			case "Camera":
				return;
			default:
				return <NormalInput item={item} preview={true} readOnly={true} />;
		}
	};
	return (
		<>
			<Popup show={view}>
				<Modal.Header className="modal-header flex-between ">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle headtitle={`${resolvedData?.form?.name}`} />
					</Modal.Title>
					<Close
						// eslint-disable-next-line react/style-prop-object
						style="close-32 close"
						close={() => setView(false)}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body
					className="modal-body-scrollable"
					style={{ height: "calc(100vh - 140px)", overflowX: "hidden" }}
				>
					<p className="fs-16 fw-500 brand-700 text-uppercase">
						{trans("Form Submission Details")}
					</p>
					<div className="row">
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Form Name")}
									item={resolvedData?.form?.name}
								/>
							</div>
						</div>

						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Task Name")}
									item={resolvedData?.task?.name}
								/>
							</div>
						</div>

						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Task Code")}
									item={resolvedData?.task?.code}
								/>
							</div>
						</div>

						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("POI")}
									item={resolvedData?.task?.poi?.name}
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Submitted At")}
									item={formatDateString(resolvedData?.submittedAt)}
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Submitted By")}
									item={resolvedData?.submittedBy?.name}
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Status")}
									item={trans(resolvedData?.status)}
								/>
							</div>
						</div>
					</div>
					<p className="fs-16 fw-500 brand-700 text-uppercase mt-2">
						{trans("Form Submission Values")}
					</p>
					{resolvedData?.formData?.map((i) => (
						<div className={`mb-2`} style={i.css} key={i.key}>
							{getInputType(i)}
						</div>
					))}
					{resolvedData?.attachments?.length > 0 && (
						<>
							<p className="fs-16 fw-500 brand-700 text-uppercase mt-2">
								{trans("Form Submission Attachments")}
							</p>
							<EditAttachments
								attachments={resolvedData?.attachments}
								viewOnly={true}
							/>
						</>
					)}
				</Modal.Body>
			</Popup>
		</>
	);
}
